import {
  DatePicker as DatePickerComponent,
  DatePickerProps,
} from '@cabonline/ui-web';
import { LanguageKey, useLocale } from '@multiplatform-apps/service-trips';
import { Locale } from 'date-fns';
import { enUS, nb, sv } from 'date-fns/locale';
import { FC } from 'react';

const datePickerLocales = new Map<LanguageKey, Locale>([
  ['en', enUS],
  ['sv', sv],
  ['no', nb],
]);

export const DatePicker: FC<DatePickerProps> = (props) => {
  const { t, currentLanguage } = useLocale();

  const ariaLabels = {
    ariaLabelPrefix: t('datePicker.ariaLabelPrefix'),
    nextMonthAriaLabel: t('datePicker.nextMonthAriaLabel'),
    previousMonthAriaLabel: t('datePicker.previousMonthAriaLabel'),
    monthPrefixAriaLabel: t('datePicker.monthPrefixAriaLabel'),
    calendarIconAriaLabel: t('datePicker.calendarIconAriaLabel'),
  };

  return (
    <DatePickerComponent
      currentLanguage={datePickerLocales.get(currentLanguage) ?? enUS}
      ariaLabels={ariaLabels}
      {...props}
    />
  );
};
